module.exports = __webpack_public_path__ + "img/item_bg3.9752e3f2.png";